import { Directive } from '@angular/core';

@Directive({
  selector: '[atRadioLabel]',
  host: {
    'class': 'at-radio-label-content'
  }
})
export class AtRadioLabel {

  constructor() { }

}
